var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "toggle-switch" }, [
    _c("input", {
      attrs: { disabled: _vm.disabled, type: "checkbox" },
      domProps: { checked: _vm.value },
      on: {
        change: function($event) {
          _vm.$emit("input", $event.target.checked)
        }
      }
    }),
    _vm._v(" "),
    _c("span", { staticClass: "slider" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1221cfb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1221cfb0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputs/jSwitch.vue
// module id = null
// module chunks = 